import { appConfig } from '../../../../../../../../../../../config/customization';
import Device from '../../../../../../../../../../../constants/deviceSizes';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    padding: '9px 0px 30px 15px',
    [Device.mobile]: {
      margin: 0,
      padding: 0
    }
  },
  dateDetails: {
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
    padding: '5px 0px',
    marginTop: 5,
    height: '25%',
    minHeight: 40,
    justifyContent: 'space-between',
    flexShrink: 0
  },
  periodDate: {
    border: `1px solid ${appConfig.colors.darkGray}`,
    borderRadius: 4,
    display: 'flex',
    width: '45%',
    height: '100%',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px 5px'
  }
};
